<form [formGroup]="customFielsDataFrom" class="col-12">
  <div #contenedor class="categories" cdkDropListGroup>
    @for (
      customField of dealCustomFieldArr;
      track customField;
      let i = $index
    ) {
      <ng-container class="mt-4">
        <div
          class="categories-item col-10 col-sm-10 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="{ item: customField, index: i }"
          (cdkDropListDropped)="drop($event)"
        >
          <div cdkDrag class="mobile-screen-input-width">
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
            <div
              class="d-flex gap-2 align-items-baseline justify-content-between mobile-screen"
            >
              <div class="d-inline-block text-1 fw-500 align-top inner f-15">
                {{ customField?.name }}
              </div>
              @if (editdeletshow != false) {
                <div id="some-icon">
                  <i
                    class="fa fa-edit edit-icon mr-2"
                    (click)="editField(customField, i)"
                  ></i>

                  <i
                    class="far fa-trash-alt del-icon"
                    (click)="removeItem(customField, i, 'removeCustomField')"
                  ></i>
                </div>
              }
            </div>
            @if (customField?.field_type_id == 1) {
              <div class="mt-2">
                <mat-form-field appearance="outline" floatLabel="always">
                  <input
                    matInput
                    type="text"
                    class="fs-2"
                    formControlName="value_{{ customField.id }}"
                  />
                </mat-form-field>
              </div>
            }
            @if (customField?.field_type_id == 2) {
              <div class="text-3 d-flex gap-2 flex-wrap mt-2">
                @for (
                  customerCusVal of customField?.deal_custom_fields_values;
                  track customerCusVal;
                  let j = $index
                ) {
                  <div>
                    <mat-checkbox
                      [value]="customerCusVal.value"
                      color="primary"
                      formControlName="value_{{
                        customerCusVal.custom_field_id
                      }}_{{ customerCusVal.value }}"
                    >
                      {{ customerCusVal.value }}
                    </mat-checkbox>
                  </div>
                }
              </div>
            }
            @if (customField?.field_type_id == 6) {
              <mat-form-field appearance="outline" floatLabel="always">
                <input
                  matInput
                  type="text"
                  formControlName="value_{{ customField.id }}_color"
                  [value]="customField.value"
                />
                <input
                  matInput
                  class="p-0 position-absolute end-0 top-0 m-2 text-1"
                  [style.background]="customField.value"
                  formControlName="value_{{ customField.id }}_color"
                  [value]="customField.value"
                  style="width: 15px; height: 15px; margin-top: 3px !important"
                  type="color"
                  (change)="
                    onColorChange($event, 'value_' + customField.id + '_color')
                  "
                />
              </mat-form-field>
            }

            @if (customField?.field_type_id == 3) {
              <div class="text-3 d-flex gap-2 flex-wrap mt-2 custom-date">
                <app-custom-date
                  formControlName="value_{{ customField.id }}_date"
                  dataType="4"
                  inputType="date"
                  fvalue="{{ dateValue }}"
                  class="w-100"
                >
                </app-custom-date>
              </div>
            }

            @if (customField?.field_type_id == 5) {
              <div class="text-3 mt-2">
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-select
                    class="text-1"
                    (selectionChange)="
                      updateSelectChange(
                        $event,
                        'value_' + customField.id + '_dropdown'
                      )
                    "
                    formControlName="value_{{ customField.id }}_dropdown"
                  >
                    <mat-option class="text-1" [value]="null">
                      <mat-icon class="vertical-align-baseline">close</mat-icon>
                      Clear
                    </mat-option>
                    @for (
                      customerCusVal of customField?.deal_custom_fields_values;
                      track customerCusVal;
                      let j = $index
                    ) {
                      <mat-option
                        class="text-1"
                        value="{{ customerCusVal.value }}"
                      >
                        {{ customerCusVal.value }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (customField?.field_type_id == 4) {
              <div class="text-3 d-flex gap-2 flex-wrap mt-2">
                <mat-radio-group
                  aria-labelledby="custom-radio-group-label"
                  formControlName="value_{{ customField.id }}_radio"
                  color="primary"
                  class="custom-radio-group"
                >
                  @for (
                    customerCusVal of customField?.deal_custom_fields_values;
                    track customerCusVal;
                    let j = $index
                  ) {
                    <mat-radio-button
                      class="custom-radio-button"
                      [value]="customerCusVal.value"
                    >
                      {{ customerCusVal.value }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            }
          </div>
        </div>
      </ng-container>
    }
  </div>
</form>
